import { render, staticRenderFns } from "./ExpedienteList.vue?vue&type=template&id=65245ea1&"
import script from "./ExpedienteList.vue?vue&type=script&lang=js&"
export * from "./ExpedienteList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports